import { createSlice } from "@reduxjs/toolkit";

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    loading: false,
    success: false,
    error: null,
    adminUsers: [],
  },
  reducers: {
    inviteAdminRequest: (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    inviteAdminSuccess: (state) => {
      state.loading = false;
    },
    inviteAdminFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetAdminState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
    adminSearchAction: (state, action) => {
      state.adminUsers = action.payload;
    },
    adminLoading: (state, action) => {
      state.loading = action.payload;
    },
    removeAdminUserFromList: (state, action) => {
      const adminList = [...state.adminUsers];
      const result = adminList.filter((item) => item.id !== action.payload);
      state.adminUsers = result;
    },
    adminError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  inviteAdminRequest,
  inviteAdminSuccess,
  inviteCoachSuccess,
  inviteAdminFail,
  resetAdminState,
  adminSearchAction,
  removeAdminUserFromList,
  adminLoading,
  adminError,
} = adminSlice.actions;
export default adminSlice.reducer;
